<script>
const replay = {
  template: `
<div class="-group -button-box -replay-box wt2-color-negative">
  <div @click="$parent.$emit('replay')"><i class="wticon wticon-next_left wt2-text-l3 wt2-color-negative"></i></div>
</div>`.normalizeSpace(),
};

const playButton = {
  template: `
<div class="-group -button-box -play-box wt2-color-negative">
   <div v-show="!playing" @click="$parent.$emit('togglePlay')">
    <i class="wticon wticon-play3 wt2-color-negative -play"></i>
   </div>
   <div v-show="playing" @click="$parent.$emit('togglePlay')">
     <i class="wticon wticon-pause2 wt2-color-negative -pause"></i>
   </div>
 </div>`.normalizeSpace(),
  props: {
    playing: {
      type: Boolean,
      required: false,
    },
  },
};

const seekBar = {
  template: `
<div class="-group -seek-box wt2-color-negative"
     :class="{ '-seekable': time.seekable }"
    @mousedown="seek"
    @mousemove="seek">
    <div class="-area -total"></div>
    <div class="-area -buffered" :style="{width: time2style(time.buffered)}"></div>
    <div class="-area -played wt2-bgcolor-primary" :style="{ width: currentTime2style }"></div>
    <div v-if="time.seekable" class="-seek-handle wt2-bgcolor-negative" :style="{ left: currentTime2style }"></div>
</div>`.normalizeSpace(),
  props: {
    time: {
      type: Object,
      required: true,
    },
  },

  computed: {
    currentTime2style() {
      return this.time2style(this.time.current);
    },
  },

  methods: {
    seek: function (e) {
      e.preventDefault();
      if (!e.buttons || !this.time.seekable) {
        return;
      }
      const bcr = e.currentTarget.getBoundingClientRect();
      const offset = e.clientX - bcr.left;
      const ratio = offset / bcr.width;
      const time = _.constrain(0, ratio * this.time.total, this.time.total);
      this.$parent.$emit('seek', { time, e });
    },

    time2style: function (time) {
      return (
        _.constrain(0, 1e2 * (time / this.time.total), 1e2).toFixed(1) + '%'
      );
    },
  },
};

const timeIndicator = {
  template: `
<div class="-group -time-box wt2-color-negative">
    <div class="-time">
        <span>{{time.current | time2String}}</span>
        <span>&nbsp;/&nbsp;</span>
        <span>{{time.total | time2String}}</span>
    </div>
</div>
       `.normalizeSpace(),
  props: {
    time: {
      type: Object,
      required: true,
    },
  },

  filters: {
    time2String: function (time) {
      let rv = '-:--';
      if (_.isDefined(time) && !isNaN(time) && time.toFixed) {
        const min = (time / 60) | 0;
        const sec = time % 60 | 0;
        rv = min + ':' + (sec < 10 ? '0' + sec : sec);
      }
      return rv;
    },
  },
};

const volumeMute = {
  template: `
<div class="-group -volume-toggle-box wt2-color-negative">
    <div v-show="!isMutted" @click="toggleMute"><i class="wticon wticon-volume-medium2 wt2-color-negative"></i></div>
    <div v-show="isMutted" @click="toggleMute"><i class="wticon wticon-volume-mute2 wt2-color-negative"></i></div>
</div>
      `.normalizeSpace(),
  props: {
    volume: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isMutted: function () {
      return 0 === this.volume.current;
    },
  },

  methods: {
    toggleMute: function () {
      if (0 === this.volume.current) {
        this.volume.current = this.volume.beforeMute;
      } else {
        this.volume.beforeMute = this.volume.current;
        this.volume.current = 0;
      }
      this.$parent.$emit('volume', this.volume.current);
    },
  },
};

const volumeBar = {
  template: `
<div class="-group -volume-seek-box wt2-color-negative"
    @mousedown="changeVolume"
    @mousemove="changeVolume">
    <div class="-area -total"></div>
    <div class="-area -current wt2-bgcolor-primary" :style="{ width: currentVolume2style }"></div>
    <div class="-seek-handle wt2-bgcolor-negative" :style="{ left: currentVolume2style }"></div>
</div>
      `.normalizeSpace(),
  props: {
    volume: {
      type: Object,
      required: true,
    },
  },

  computed: {
    currentVolume2style() {
      return this.volume2style(this.volume.current);
    },
  },

  methods: {
    changeVolume: function (e) {
      e.preventDefault();
      if (!e.buttons) {
        return;
      }
      const bcr = e.currentTarget.getBoundingClientRect();
      const offset = e.clientX - bcr.left;
      const volume = _.constrain(0, offset / bcr.width, 1);
      this.volume.current = volume;
      this.volume.beforeMute = volume;
      this.$parent.$emit('volume', volume);
    },

    volume2style: function (volume) {
      return _.constrain(0, 1e2 * volume, 1e2).toFixed(1) + '%';
    },
  },
};

const fullscreen = {
  template: `
<div class="-group -fullscreen-box wt2-color-negative">
   <div @click="$parent.$emit('toggleFullscreen')"><i class="wticon wticon-expand wt2-color-negative"></i></div>
</div>`.normalizeSpace(),
};

const presetTypesMap = {
  regular: [
    'playButton',
    'seekBar',
    'timeIndicator',
    'volumeMute',
    'volumeBar',
  ],
  'regular-plus': [
    'playButton',
    'seekBar',
    'timeIndicator',
    'volumeMute',
    'volumeBar',
    'fullscreen',
  ],
  lite: ['replay', 'playButton', 'seekBar', 'volumeMute', 'volumeBar'],
};

export default {
  components: {
    replay,
    playButton,
    seekBar,
    timeIndicator,
    volumeMute,
    volumeBar,
    fullscreen,
  },
  presetTypesMap,
};
</script>
